import { Switch } from 'devextreme-react/switch';

import React from 'react';

export const FormSwitch = ({ field, form: { errors, setFieldValue }, ...props }) => {
  const { onChange, col, label, help } = props;

  return (
    <div className={`col-lg-${col}`} style={{ textAlign: 'center' }}>
      <label className="control-label">
        {label}
        {help && (
          <span data-toggle="tooltip" data-placement="top" title={help}>
            <i className="fa fa-question-circle" />
          </span>
        )}
      </label>
      <div className={`form-group ${errors[field.name] ? 'has-error' : null}`}>
        <Switch
          {...field}
          width="50%"
          {...props}
          isValid={!errors[field.name]}
          onValueChanged={option => {
            setFieldValue(field.name, option ? option.value : '');

            onChange && onChange(option);
          }}
        />
      </div>
    </div>
  );
};
